import dynamic from 'next/dynamic';

import ArtistMenu from '../artist-menu/artist-menu';
import Location from '../icons-af/location';
import {P} from '../typography/typography';
import './product-artist.scss';
import {StyledViewAllBtn} from './styles';

const ProductCarouselRelatedWithNoSSR = dynamic(
  () => import('../product-carousel-related/product-carousel-related'),
  {ssr: false},
);

const ProductArtist = ({artist, mltByArtist, className}) => {
  const stripHtml = (text) =>
    text
      .replace(/(<([^>]+)>)/gi, '')
      .replace(/(&nbsp;)/g, ' ')
      .replace(/(&amp;)/g, '&')
      .replace(/\.(?![ ])/g, '. ')
      .replace(/\,(?![ ])/g, ', ')
      .replace(/\!(?![ ])/g, '! ')
      .replace(/\?(?![ ])/g, '. ')
      .trim();

  const paragraphTruncate = (text, length) => text.split(' ').splice(0, length).join(' ') + '...';

  return (
    <section className={'artist-info' + (className ? ` ${className}` : '')}>
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <ArtistMenu artist={artist} />
          </div>

          <div className="artist-introduction col-lg-7 ">
            <P style="p1">
              <Location width="20px" height="20px" /> {artist.country}
              <br />
              <br />
              <strong>About</strong>
              <br />
              {paragraphTruncate(stripHtml(artist.intro), 30)}&nbsp;
              <a href={`/artist/${artist.slug}/about/`}>Read more</a>
            </P>
          </div>
        </div>

        <ProductCarouselRelatedWithNoSSR items={mltByArtist} type="product" small />

        <StyledViewAllBtn href={`/artist/${artist.slug}/`}>View all</StyledViewAllBtn>
      </div>
    </section>
  );
};

export default ProductArtist;
